import React from 'react';
import {Card, CardActions, CardContent} from "@mui/material";
import {CardData, CardTitle} from "@atttomyx/react-components";
import {datetime, numbers} from "@atttomyx/shared-utils";
import {renderRanks} from "../../utils/ranks";

const DocumentCard = (props) => {
    const { document, filters, children } = props;

    return <Card className="document-card" raised={true}>
        <CardContent>
            <CardTitle>
                {document.fileName}
            </CardTitle>
            <CardData
                filters={filters}
                data={document}
                keyToMetadata={{
                    contentType: {
                        title: "Type",
                    },
                    size: {
                        title: "Size",
                        formatter: numbers.abbreviateNumber,
                    },
                    ranks: {
                        title: "Ranks",
                        formatter: renderRanks,
                    },
                    order: {
                        title: "Index",
                    },
                    created: {
                        title: "Created",
                        formatter: datetime.getFullDateAndTime,
                    },
                    updated: {
                        title: "Updated",
                        formatter: datetime.getFullDateAndTime,
                    },
                }}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default DocumentCard;
